import { z } from 'zod';
import { zId, zOptId, zOptText, zText } from './common';

export const conversationSchema = z.object({
  kind: z.enum(['direct', 'group', 'team']),
  title: zOptText(120),
  groupId: zOptId,
  teamId: zOptId,
  memberPersonIds: z.array(zId).max(500).default([]),
});
export const messageSchema = z.object({ body: zText(4000) });
